<template>
  <b-modal ref="modal" hide-footer title="Custom Email">
    <b-row class="my-1">
      <b-col md="3">
        <label for="notes">Recipients</label>
      </b-col>
      <b-col md="9">
        <multiselect
          v-model="form.recipients"
          tag-placeholder="Add this email address"
          placeholder="Add email address"
          track-by="emailAddress"
          label="displayName"
          :options="emails"
          :multiple="true"
          :hide-selected="true"
          :taggable="true"
          :block-keys="['Tab']"
           @tag="addTag"
        ></multiselect>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="notes">Message</label>
      </b-col>
      <b-col md="9">
        <b-form-textarea
          id="notes"
          v-model="form.message"
          rows="6"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <b-button type="reset" variant="danger" @click="hideModal">
          <font-awesome-icon icon="times" /> Close
        </b-button>
        &nbsp;
        <b-button type="submit" variant="success" class="margin-right" :disabled="form.message == '' || form.recipients.length == 0" @click="send">
          <font-awesome-icon icon="check" /> Send
        </b-button>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"></b-col>
      <b-col md="9">
        <Feedback ref="saveFeedback"/>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import Feedback from '@/components/shared/Feedback.vue';

export default {
  components: { Multiselect, Feedback },
  props: [ 'companyId' ],
  data() {
    return {
      form: {
        message: "",
        recipients: []
      },
      emails: []
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
      this.loadEmailAddresses();
    },
    hideModal() {
      this.form = {
        message: "",
        recipients: []
      }
      this.$refs["modal"].hide();
    },
    loadEmailAddresses() {
      this.$http.get('companynotes/' + this.$props.companyId + '/emailcontacts').then((response) => {
        var addresses = [];
        response.data.forEach(function(recip) {
          addresses.push({
            displayName: recip.fullname + ' (' + recip.emailAddress + ')',
            fullName: recip.fullname,
            emailAddress: recip.emailAddress
          });
        });
        this.emails = addresses;
      })
    },
    send() {
      if (this.form.recipients && this.form.recipients.length > 0) {
        this.$http.post('companynotes/' + this.$props.companyId + '/email', this.form).then(() => {
          this.hideModal();
        });
      }
    },
    addTag(newTag) {

      var re = /\S+@\S+\.\S+/;

      this.$refs.saveFeedback.clear();

      if (!re.test(newTag)) {
        this.$refs.saveFeedback.showError("Invalid Email Address");
        return false;
      }

      var newTabObject = {
        displayName: newTag,
        fullName: "",
        emailAddress: newTag
      };

      this.form.recipients.push(newTabObject)
    }
  },
};
</script>

<style scoped>
</style>
